var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "btn highlight",
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _vm.highlight
        ? _c(
            "div",
            {
              staticClass: "container-img",
              style: { backgroundColor: _vm.storySelected.background.color },
            },
            [
              _vm.highlight.id && _vm.highlight.data
                ? _c("img", { attrs: { src: _vm.highlight.data.img } })
                : _vm.storySelected.background.file
                ? [
                    _vm.storySelected.background.file.info.type2 == "image"
                      ? _c("img", {
                          attrs: { src: _vm.storySelected.background.file.url },
                        })
                      : _vm.storySelected.background.file.info.type2 == "video"
                      ? _c("video", {
                          staticClass: "source",
                          attrs: {
                            src: _vm.storySelected.background.file.url,
                            type: _vm.storySelected.background.file.info.type,
                            preload: "metadata",
                            onloadedmetadata: "true",
                            muted: "",
                            loop: "",
                            playsinline: "",
                          },
                          domProps: { muted: true },
                        })
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _c("img", {
        attrs: {
          src: require("@/assets/img/instagram/instagram_story_highlight_filled_32.png"),
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }